import { getCssVariable, Select, ToolbarButton } from '@fourthwall/components';
import { TrashIcon } from '@fourthwall/icons';
import React from 'react';
import tinycolor from 'tinycolor2';
import { BadgePreview } from '../../../../components/BadgePreview';
import { FormFields } from '../../hooks/useBadgeForm/types';
import { ColorInput } from '../ColorInput';
import { EmojiInput } from '../EmojiInput';
import { MainInputsLayout } from '../MainInputsLayout';
import { MONTHS_FROM_OPTIONS, MONTHS_TO_OPTIONS } from './const';
import { getEmojiIcon } from '../../../../utils';
import * as S from './styled';
export const StreakRule = ({ memberStreakBadge, form }) => {
    const colorOnBackground = getCssVariable('--color-on-background');
    const renderBadgesPreview = () => {
        if (memberStreakBadge.badge.monthsFrom === 0 &&
            (memberStreakBadge.badge.monthsTo >= 2 || memberStreakBadge.badge.monthsTo == 0)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(BadgePreview, { emoji: getEmojiIcon(memberStreakBadge.badge.emoji), textColor: memberStreakBadge.badge.textColor, borderColor: memberStreakBadge.badge.borderColor, backgroundColor: memberStreakBadge.badge.backgroundColor, text: "New member", title: "Up to 1 month" }),
                React.createElement(BadgePreview, { emoji: getEmojiIcon(memberStreakBadge.badge.emoji), textColor: memberStreakBadge.badge.textColor, borderColor: memberStreakBadge.badge.borderColor, backgroundColor: memberStreakBadge.badge.backgroundColor, text: " X-month member", title: "From 2 months" })));
        }
        return (React.createElement(BadgePreview, { emoji: getEmojiIcon(memberStreakBadge.badge.emoji), textColor: memberStreakBadge.badge.textColor, borderColor: memberStreakBadge.badge.borderColor, backgroundColor: memberStreakBadge.badge.backgroundColor, text: memberStreakBadge.badge.monthsFrom === 0 && memberStreakBadge.badge.monthsTo === 1
                ? 'New member'
                : ' X-month member' }));
    };
    return (React.createElement(S.Outer, null,
        React.createElement(S.Container, null,
            React.createElement(S.Inputs, null,
                React.createElement(Select, { label: "From", value: memberStreakBadge.badge.monthsFrom?.toString(), options: MONTHS_FROM_OPTIONS, onValueChange: (value) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    monthsFrom: parseInt(value),
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } }),
                React.createElement(Select, { label: "To", value: memberStreakBadge.badge.monthsTo?.toString(), options: MONTHS_TO_OPTIONS, onValueChange: (value) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    monthsTo: parseInt(value),
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } })),
            renderBadgesPreview(),
            React.createElement(MainInputsLayout, null,
                React.createElement(EmojiInput, { emoji: getEmojiIcon(memberStreakBadge.badge.emoji), onChange: (emoji) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    emoji,
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } }),
                React.createElement(ColorInput, { label: "Border", color: memberStreakBadge.badge.borderColor, defaultColor: tinycolor(colorOnBackground).setAlpha(0.3).toRgbString(), onChange: (color) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    borderColor: color,
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } }),
                React.createElement(ColorInput, { label: "Background", color: memberStreakBadge.badge.backgroundColor, defaultColor: tinycolor(colorOnBackground).setAlpha(0.1).toRgbString(), onChange: (color) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    backgroundColor: color,
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } }),
                React.createElement(ColorInput, { label: "Text", color: memberStreakBadge.badge.textColor, defaultColor: colorOnBackground, onChange: (color) => {
                        const newMemberStreakBadges = form.values.memberStreakBadges.map((badge, index) => {
                            if (index === memberStreakBadge.index) {
                                return {
                                    ...badge,
                                    textColor: color,
                                };
                            }
                            return badge;
                        });
                        form.setFieldValue(FormFields.memberStreakBadges, newMemberStreakBadges);
                    } }))),
        React.createElement(ToolbarButton, { icon: TrashIcon, size: "small", onClick: () => {
                form.setFieldValue(FormFields.memberStreakBadges, form.values.memberStreakBadges.filter((badge, index) => index !== memberStreakBadge.index));
            } })));
};
